/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import Slider from '@mui/material/Slider';
import { useEffect, useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { formatDinheiro } from '../../utils/formatDinheiro';
import React from 'react';
import * as S from './ProdutoView.style';
import assets from '../../assets';

import { colors } from 'utils/colors';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { TProduto } from '@typings/produto';

const ProdutoView = (props) => {
  const produtoLista = props.produtosListado as TProduto[];
  const [produtoIndex, setProdutoIndex] = useState(0);
  const [caracteristicaIndex, setCaracteristicaIndex] = useState(0);
  const [quantidade, setQuantidade] = useState(0);
  const [estado, setEstado] = useState(null);
  const [icmsTipo, setICMSTipo] = useState('');
  const [partilha, setPartilha] = useState('');
  const [precoSugerido, setPrecoSugerido] = useState(0);
  const [precoMax, setPrecoMax] = useState(0);
  const [precoMin, setPrecoMin] = useState(0);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [largeImageURL, setLargeImageURL] = useState('');
  const [lockPreco, setLockPreco] = useState(0);
  const [indexPicture, setIndexPicture] = useState(0);
  const [valorIpiManual, setValorIpiManual] = useState(0);
  const [freteFixo, setFreteFixo] = useState(0);
  const [corProduto, setCor] = useState<any>({
    nome: 'padrão',
    hexadecimal: colors.branco,
  });
  const [valorSemIpi, setValorSemIpi] = useState('');
  const [valorComIpi, setValorComIpi] = useState('');
  const [editandoSemIpi, setEditandoSemIpi] = useState(false);
  const [editandoComIpi, setEditandoComIpi] = useState(false);

  const resetAll = (newValue) => {
    setQuantidade(0);
    setCor({
      nome: 'padrão',
      hexadecimal: colors.branco,
    });
    setProdutoIndex(produtoLista.indexOf(newValue));
  };

  useEffect(() => {
    setProdutoIndex(0);
    setCaracteristicaIndex(0);
    setIndexPicture(0);
    resetAll(0);
    if (icmsTipo.length > 3)
      setLockPreco(
        icmsTipo === 'consumo'
          ? Number(produtoLista?.[produtoIndex]?.precoConsumo)
          : Number(produtoLista?.[produtoIndex]?.precoRevenda),
      );
  }, [produtoLista]);

  const testeNaN = (value) => {
    if (Number.isNaN(value) || value === undefined) return 0;
    return value;
  };

  const handlePicture = (value) => {
    const quantidadeP = produtoLista?.[produtoIndex]?.caracteristicas[caracteristicaIndex].fotos.length - 1;
    let index = value + indexPicture;
    if (index > quantidadeP) index = 0;
    if (index < 0) index = quantidadeP;
    setIndexPicture(index);
  };

  const handleImageClick = (url) => {
    setLargeImageURL(url);
    setOpenImageModal(true);
  };

  const selectEstado = (id) => {
    const estadoP = props.uf.find((e) => e.id === id);
    setEstado(estadoP);
  };

  const calculoIpiParcial = (valor) => {
    const calculo = Number(valor) * Number(produtoLista?.[produtoIndex]?.ipi / 100);
    return calculo;
  };

  const calculoIpiCompleto = (valor) => {
    const ipi = valorIpiManual > 0 ? valorIpiManual : produtoLista?.[produtoIndex]?.ipi;
    const calculo = Number(valor) + Number(valor) * (Number(ipi) / 100);
    return calculo;
  };

  const calculoComissao = (valor) => {
    const calculo = Number(valor) * (Number(props.vendedor.comissao) / 100);
    return calculo;
  };

  const calculoPartilha = (valor) => {
    const calculo = Number(valor) * (Number(estado?.[partilha]) / 100);
    return calculo;
  };

  const calculoMargin = (valor) => {
    const calculo = Number(valor) * (Number(produtoLista?.[produtoIndex]?.margin) / 100);
    return calculo;
  };

  const calculoIcms = (valor) => {
    const calculo = Number(valor) * (Number(estado?.[icmsTipo]) / 100);
    return calculo;
  };

  const calculoImposto = (valor) => {
    const calculo = Number(valor) * (Number(produtoLista?.[produtoIndex]?.imposto) / 100);
    return calculo;
  };

  const calculoFrete = (valor) => {
    const calculo = Number(valor) * (Number(produtoLista?.[produtoIndex]?.frete) / 100);
    return calculo;
  };

  const total = (valor) => {
    const calculo = Number(freteFixo + calculoIpiCompleto(Number(valor)) * quantidade);
    return parseFloat(calculo.toFixed(2));
  };

  const resultadoPorPrecoBase = (valor) => {
    const calculo = precoSugerido - Number(valor);
    return parseFloat(calculo.toFixed(2));
  };

  const resultado = (v) => {
    const precoCIpi = calculoIpiCompleto(v);
    const res =
      Number(v) -
      (Number(produtoLista?.[produtoIndex]?.precoBase) +
        Number(calculoIcms(precoCIpi)) +
        Number(calculoIpiParcial(v)) +
        Number(calculoPartilha(v)) +
        Number(calculoImposto(v)) +
        Number(calculoFrete(v)) +
        Number(calculoComissao(v)) +
        Number(calculoMargin(v)));

    return parseFloat(res.toFixed(4));
  };

  useEffect(() => {
    const preco = Number(lockPreco);
    setPrecoSugerido(preco);
    setPrecoMax(preco * 0.5 + preco);
    const min = resultado(preco);
    if (!Number.isNaN(min)) {
      setPrecoMin(preco - resultado(preco));
    }
    setValorSemIpi(preco.toFixed(4));
    setValorComIpi(calculoIpiCompleto(preco).toFixed(2));
  }, [lockPreco, produtoIndex, partilha, estado]);

  useEffect(() => {
    if (icmsTipo.length > 3)
      setLockPreco(
        icmsTipo === 'consumo'
          ? Number(produtoLista?.[produtoIndex]?.precoConsumo)
          : Number(produtoLista?.[produtoIndex]?.precoRevenda),
      );
    const extra = {
      estado: estado?.nome,
      icms: icmsTipo,
      icmsValor: estado?.[icmsTipo],
      partilha: partilha,
      partilhaValor: estado?.[partilha],
      comissao: props.vendedor.comissao,
      valorIpi: calculoIpiCompleto(precoSugerido).toFixed(4),
      valorTotal: total(Number(precoSugerido)),
      resultadoFinal: resultadoPorPrecoBase(resultado(precoSugerido)),
      hexadecimal: corProduto.hexadecimal,
    };
    const produto = { ...produtoLista?.[produtoIndex] };
    produto.extra = { ...extra };
    const valorFrete = total(Number(precoSugerido)) * (Number(produtoLista?.[produtoIndex]?.frete) / 100);
    const valor = precoSugerido;
    const cor = corProduto.nome;
    props.produtoSelecionado({
      produto,
      valor,
      quantidade,
      valorFrete,
      cor,
    });
  }, [produtoIndex, precoSugerido, quantidade, estado, icmsTipo, partilha, corProduto]);

  const onChangeRange = (e, newValue) => {
    setPrecoSugerido(newValue);
    setValorSemIpi(newValue.toFixed(4));
    setValorComIpi(calculoIpiCompleto(newValue).toFixed(2));
  };

  const textFieldRef = useRef(null);

  useEffect(() => {
    const handleWheel = (e) => e.preventDefault();

    if (textFieldRef.current) {
      textFieldRef.current.addEventListener('wheel', handleWheel);
    }
    return () => {
      if (textFieldRef.current) {
        textFieldRef.current.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

  const handleValorSemIpiChange = (event) => {
    const inputValue = event.target.value;
    const cleanedValue = inputValue.replace(/[^0-9.,]/g, '').replace(',', '.');
    setEditandoSemIpi(true);
    setValorSemIpi(cleanedValue);
  };

  const handleValorSemIpiBlur = () => {
    setEditandoSemIpi(false);
    const newValorComIpi = calculoIpiCompleto(parseFloat(valorSemIpi)).toFixed(2);
    setValorComIpi(newValorComIpi);
    setPrecoSugerido(parseFloat(valorSemIpi));
  };

  const handleValorComIpiChange = (event) => {
    const inputValue = event.target.value;
    const cleanedValue = inputValue.replace(/[^0-9.,]/g, '').replace(',', '.');
    setEditandoComIpi(true);
    setValorComIpi(cleanedValue);
  };

  const handleValorComIpiBlur = () => {
    setEditandoComIpi(false);
    const ipi = valorIpiManual > 0 ? valorIpiManual : produtoLista?.[produtoIndex]?.ipi;
    const newValorSemIpi = (parseFloat(valorComIpi) / (1 + ipi / 100)).toFixed(4);
    setValorSemIpi(newValorSemIpi);
    setPrecoSugerido(parseFloat(newValorSemIpi));
  };

  return (
    <S.ContainerWrapperCalculadora>
      <S.ProdutoViewBox>
        {!props.copia && (
          <>
            <S.BoxSelectProduto>
              <Autocomplete
                disableClearable
                disablePortal
                id="combo-box-demo"
                options={produtoLista}
                sx={{ width: '100%' }}
                value={produtoLista?.[produtoIndex]}
                getOptionLabel={(option) => option.nome}
                onChange={(event, newValue) => {
                  resetAll(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="SELECIONE O PRODUTO" />}
              />
            </S.BoxSelectProduto>
          </>
        )}
        {produtoLista?.[produtoIndex]?.nome && (
          <>
            <S.ImgProdutoBox>
              {produtoLista?.[produtoIndex]?.caracteristicas[caracteristicaIndex]?.fotos[indexPicture]?.imagem ? (
                <div
                  onClick={() =>
                    handleImageClick(
                      produtoLista?.[produtoIndex]?.caracteristicas[caracteristicaIndex].fotos[indexPicture].imagem,
                    )
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={produtoLista?.[produtoIndex]?.caracteristicas[caracteristicaIndex].fotos[indexPicture].imagem}
                    alt={'Imagem do produto ' + produtoLista?.[produtoIndex]?.nome}
                    width={100}
                  />
                </div>
              ) : (
                <img src={assets.images.produto} alt="Produto sem imagem definida!" />
              )}
              {produtoLista?.[produtoIndex]?.caracteristicas[caracteristicaIndex].fotos.length > 1 && (
                <S.BoxPreviewImg>
                  <IconButton color="success" aria-label="foto anterior" onClick={() => handlePicture(1)}>
                    <NavigateBeforeIcon />
                  </IconButton>
                  <IconButton color="success" aria-label="próxima foto" onClick={() => handlePicture(-1)}>
                    <NavigateNextIcon />
                  </IconButton>
                </S.BoxPreviewImg>
              )}
            </S.ImgProdutoBox>
            <S.TilteProduto>
              <p>{produtoLista?.[produtoIndex]?.nome}</p>
            </S.TilteProduto>
            PRODUTO
            <S.BoxTitleProduto id="nomeProduto"></S.BoxTitleProduto>
            <S.BoxTamanhoProduto>
              {produtoLista?.[produtoIndex]?.largura} X {produtoLista?.[produtoIndex]?.altura} mm
            </S.BoxTamanhoProduto>
          </>
        )}
        <Dialog open={openImageModal} onClose={() => setOpenImageModal(false)}>
          <img src={largeImageURL} alt="Imagem em Tamanho Maior" />
        </Dialog>
        {produtoLista?.[produtoIndex]?.caracteristicas[caracteristicaIndex].cores.length > 0 && (
          <>
            <S.CoresTiTle>cores disponíveis</S.CoresTiTle>
            <S.BoxVarianteCores>
              <S.BoxCores>
                <ul>
                  {produtoLista?.[produtoIndex]?.caracteristicas[caracteristicaIndex].cores?.map((item, index) => (
                    <li
                      key={index}
                      onChange={() => {
                        setCor(item);
                      }}
                    >
                      <label>
                        <input type="radio" name="color" value="1" />
                        <S.Swatch style={{ background: item.hexadecimal }}></S.Swatch>
                      </label>
                    </li>
                  ))}
                </ul>
              </S.BoxCores>
            </S.BoxVarianteCores>
          </>
        )}
      </S.ProdutoViewBox>
      <S.BoxCalculadora>
        <S.BoxTaxasOpcoes>
          <S.OpcoesWrapper>
            <S.BoxInputPrimario>
              <label>Estado</label>
              <select
                name="estado"
                id="estado"
                onChange={(e) => selectEstado(e.target.value)}
                defaultValue={'-1'}
                disabled={props.copia}
              >
                <option value="-1" disabled>
                  Selecione UF
                </option>
                {props.uf.map((section) => (
                  <option key={section.id} value={section.id}>
                    {section.nome}
                  </option>
                ))}
              </select>
            </S.BoxInputPrimario>

            <S.BoxInputPrimario>
              <label>Partilha</label>
              <select
                id="partilhaSelect"
                name="partilhaSelect"
                defaultValue={'-1'}
                disabled={estado === null || props.copia}
                onChange={(e) => setPartilha(e.target.value)}
              >
                <option disabled value="-1">
                  Selecione
                </option>
                <option value="contribuinte">Contribuinte</option>
                <option value="naoContribuinte">Não Contribuinte</option>
              </select>
            </S.BoxInputPrimario>

            <S.BoxInputPrimario>
              <label>Tipo do Cliente</label>
              <select
                name="tipoCliente"
                id="tipoCliente"
                defaultValue={-1}
                disabled={estado === null || partilha === '' || props.copia}
                onChange={(e) => {
                  setICMSTipo(e.target.value);
                  setLockPreco(
                    e.target.value === 'consumo'
                      ? Number(produtoLista?.[produtoIndex]?.precoConsumo)
                      : Number(produtoLista?.[produtoIndex]?.precoRevenda),
                  );
                }}
              >
                <option disabled value="-1">
                  Selecione
                </option>
                <option value={'consumo'}>Consumo</option>
                <option value={'revenda'}>Revenda</option>
              </select>
            </S.BoxInputPrimario>

            <S.BoxInputPrimario>
              <label>Quantidade</label>
              <input
                type="number"
                id="qty"
                name="qty"
                disabled={estado === null || props.copia || !produtoLista?.[produtoIndex]?.created_at}
                onChange={(e) => setQuantidade(Number(e.target.value))}
                ref={textFieldRef}
                value={
                  estado !== null && !props.copia && quantidade > 0 && produtoLista?.[produtoIndex]?.created_at
                    ? quantidade
                    : ''
                }
              />
            </S.BoxInputPrimario>
          </S.OpcoesWrapper>
          <S.BoxTaxasWrapper>
            <S.BoxInputSecundario>
              <label>ICMS</label>
              <input id="icms" type="text" value={testeNaN(estado?.[icmsTipo]) + '%'} disabled />
            </S.BoxInputSecundario>
            <S.BoxInputSecundario>
              <label>IPI</label>
              <input type="text" value={produtoLista?.[produtoIndex]?.ipi + '%'} disabled />
            </S.BoxInputSecundario>
            <S.BoxInputSecundario>
              <label>Partilha do Estado</label>
              <input id="partilha" type="text" value={testeNaN(estado?.[partilha]) + '%'} disabled />
            </S.BoxInputSecundario>
            <S.BoxInputSecundario>
              <label>Frete</label>
              <input type="text" value={produtoLista?.[produtoIndex]?.frete + '%'} disabled />
            </S.BoxInputSecundario>
            <S.BoxInputSecundario>
              <label>Comissão</label>
              <input type="text" value={props.vendedor.comissao + '%'} disabled />
            </S.BoxInputSecundario>
          </S.BoxTaxasWrapper>
        </S.BoxTaxasOpcoes>
        <S.BoxAjusteWrapper>
          {!props.copia && <S.TitleSlice>AJUSTE DE PREÇO</S.TitleSlice>}
          {!props.copia && (
            <>
              <S.SlideBoxWrapper>
                <S.BoxRange>
                  MIN. <br />
                  <p>{precoMin.toFixed(2)}</p>
                </S.BoxRange>
                <Slider
                  aria-label="Valor do produto"
                  value={Number(Number(precoSugerido).toFixed(2))}
                  min={precoMin}
                  max={precoMax}
                  step={0.01}
                  valueLabelDisplay="auto"
                  onChange={onChangeRange}
                  sx={{
                    width: '80%',
                    color: 'success.main',
                  }}
                />
                <S.BoxRange end={true}>
                  MAX.
                  <br />
                  <p>{precoMax.toFixed(2)}</p>
                </S.BoxRange>
              </S.SlideBoxWrapper>
              <div style={{ marginTop: '20px' }}>O valor precisa estar entre preço min e preço max</div>
              <TextField
                label="Valor S/IPI"
                size="small"
                value={valorSemIpi}
                onChange={handleValorSemIpiChange}
                onBlur={handleValorSemIpiBlur}
                style={{ marginTop: '1rem', marginRight: '20px' }}
                inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
              />
              <TextField
                label="Valor C/IPI"
                size="small"
                value={valorComIpi}
                onChange={handleValorComIpiChange}
                onBlur={handleValorComIpiBlur}
                style={{ marginTop: '1rem' }}
                inputProps={{ inputMode: 'decimal', pattern: '[0-9]*' }}
              />
            </>
          )}
          <S.BoxResultado>
            <S.BoxCalculadoraWrapper>
              <S.TitlePrefixo>Valor s/IPI</S.TitlePrefixo>
              <S.ResultadoCalculo id="precoSugerido">
                {formatDinheiro(parseFloat(valorSemIpi) || 0, 4)}
              </S.ResultadoCalculo>
            </S.BoxCalculadoraWrapper>
            <S.BoxCalculadoraWrapper>
              <S.TitlePrefixo>Preço c/ipi</S.TitlePrefixo>
              <S.ResultadoCalculo id="ipiPreco">{formatDinheiro(parseFloat(valorComIpi) || 0, 2)}</S.ResultadoCalculo>
            </S.BoxCalculadoraWrapper>
            <S.BoxCalculadoraWrapper>
              <S.TitlePrefixo>orçamento total</S.TitlePrefixo>
              <S.ResultadoCalculo>{formatDinheiro(total(Number(precoSugerido)), 2)}</S.ResultadoCalculo>
            </S.BoxCalculadoraWrapper>
            <S.BoxCalculadoraWrapper>
              <S.TitlePrefixo>resultado</S.TitlePrefixo>
              <S.ResultadoCalculo id="resultado">
                {formatDinheiro(testeNaN(resultadoPorPrecoBase(resultado(precoSugerido))), 2)}
              </S.ResultadoCalculo>
            </S.BoxCalculadoraWrapper>
          </S.BoxResultado>
          {props.copia && <button onClick={() => props.removerProduto()}>Remover do orçamento</button>}
        </S.BoxAjusteWrapper>
      </S.BoxCalculadora>
    </S.ContainerWrapperCalculadora>
  );
};

export default ProdutoView;
